import { render, staticRenderFns } from "./PosturasListByStatus.vue?vue&type=template&id=3d1cd9a0"
import script from "./PosturasListByStatus.vue?vue&type=script&lang=js"
export * from "./PosturasListByStatus.vue?vue&type=script&lang=js"
import style0 from "./PosturasListByStatus.vue?vue&type=style&index=0&id=3d1cd9a0&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports